export const getLocationString = ({ pathname, search, hash } = {}) =>
  `${pathname}${search}${hash}`
